// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import {
//   Users,
//   FileText,
//   CreditCard,
//   Upload,
//   ListChecks,
//   LayoutDashboard,
//   Receipt, // for bills
//   IndianRupee, // for total amount
//   Building2, // for buyers
// } from "lucide-react";
// import { Api } from "../Api/Api";

// const Dashboard1 = () => {
//   const [bills, setBills] = useState([]);
//   const [companies, setCompanies] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const API_BILLS = `${Api}bills/get.php`;
//   const API_BUYERS = `${Api}buyer/get.php`;

//   // ✅ Dynamic font hook
//   const useFitText = (text) => {
//     const ref = useRef();
//     const [fontSize, setFontSize] = useState(32);

//     useEffect(() => {
//       const resize = () => {
//         if (!ref.current) return;
//         let currentSize = 32;
//         const maxWidth = ref.current.offsetWidth;
//         const span = document.createElement("span");
//         span.style.visibility = "hidden";
//         span.style.position = "absolute";
//         span.style.whiteSpace = "nowrap";
//         span.innerText = text;
//         document.body.appendChild(span);

//         while (span.offsetWidth > maxWidth && currentSize > 10) {
//           currentSize -= 1;
//           span.style.fontSize = currentSize + "px";
//         }

//         setFontSize(currentSize);
//         document.body.removeChild(span);
//       };

//       resize();
//       window.addEventListener("resize", resize);
//       return () => window.removeEventListener("resize", resize);
//     }, [text]);

//     return [ref, fontSize];
//   };

//   // Fetch bills
//   useEffect(() => {
//     axios
//       .get(API_BILLS)
//       .then((res) => {
//         if (res.data.ok) {
//           setBills(res.data.bills || []);
//         }
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Fetch bills error:", err);
//         setLoading(false);
//       });
//   }, []);

//   // Fetch buyers/companies
//   useEffect(() => {
//     const fetchCompanies = async () => {
//       try {
//         const res = await fetch(API_BUYERS);
//         if (!res.ok) throw new Error("Failed to fetch company data");
//         const data = await res.json();
//         setCompanies(data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchCompanies();
//   }, []);

//   // Calculate totals
//   const totalBills = bills.length;
//   const totalGrandAmount = bills.reduce(
//     (sum, bill) => sum + parseFloat(bill.paid_amount || 0),
//     0
//   );
//   const totalBuyers = companies.length;

//   // ✅ Apply useFitText
//   const [billsRef, billsFont] = useFitText(`${totalBills}`);
//   const [amountRef, amountFont] = useFitText(
//     `₹ ${totalGrandAmount.toFixed(2)}`
//   );
//   const [buyersRef, buyersFont] = useFitText(`${totalBuyers}`);

//   if (loading) {
//     return <div className="p-6 text-gray-600">Loading dashboard...</div>;
//   }

//   return (
//     <div className="p-6">
//       <h1 className="text-2xl font-bold mb-6 flex items-center gap-2">
//         <LayoutDashboard /> Dashboard
//       </h1>

     

//       {/* ✅ Summary Cards with dynamic text fit */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 mb-10">
//         {/* <div className="bg-blue-500 text-white p-6 rounded-xl shadow flex items-center justify-between"> */}
//         <div className="bg-red-500 text-white p-6 rounded-xl shadow flex items-center justify-between">
//           <div>
//             <p className="text-sm font-medium opacity-90">Total Bills</p>
//             <p
//               ref={billsRef}
//               style={{ fontSize: `${billsFont}px` }}
//               className="font-bold mt-2"
//             >
//               {totalBills}
//             </p>
//           </div>
//           <Receipt size={40} className="opacity-80" />
//         </div>

//         <div className="bg-green-500 text-white p-6 rounded-xl shadow flex items-center justify-between">
//           <div>
//             <p className="text-sm font-medium opacity-90">Total Amount</p>
//             <p
//               ref={amountRef}
//               style={{ fontSize: `${amountFont}px` }}
//               className="font-bold mt-2"
//             >
//               ₹ {totalGrandAmount.toFixed(2)}
//             </p>
//           </div>
//           <IndianRupee size={40} className="opacity-80" />
//         </div>

//         {/* <div className="bg-purple-500 text-white p-6 rounded-xl shadow flex items-center justify-between"> */}
//         <div className="bg-indigo-500 text-white p-6 rounded-xl shadow flex items-center justify-between">
//           <div>
//             <p className="text-sm font-medium opacity-90">Total Buyers</p>
//             <p
//               ref={buyersRef}
//               style={{ fontSize: `${buyersFont}px` }}
//               className="font-bold mt-2"
//             >
//               {totalBuyers}
//             </p>
//           </div>
//           <Building2 size={40} className="opacity-80" />
//         </div>
//       </div>

//       {/* ⚡ Quick Actions */}
//       <h2 className="text-xl font-semibold mb-4">⚡ Quick Actions</h2>
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
//         <Link
//           to="/admin/buyer"
//           className="bg-white hover:shadow-lg transition-all p-5 rounded-xl border flex flex-col items-center text-center"
//         >
//           <Users size={28} className="text-blue-500 mb-2" />
//           <span className="font-semibold">Buyer Info</span>
//         </Link>
//         <Link
//           to="/admin/voucher-entry"
//           className="bg-white hover:shadow-lg transition-all p-5 rounded-xl border flex flex-col items-center text-center"
//         >
//           <FileText size={28} className="text-green-500 mb-2" />
//           <span className="font-semibold">Voucher Entry</span>
//         </Link>
//         <Link
//           to="/admin/billing-details"
//           className="bg-white hover:shadow-lg transition-all p-5 rounded-xl border flex flex-col items-center text-center"
//         >
//           <CreditCard size={28} className="text-orange-500 mb-2" />
//           <span className="font-semibold">Bill Details</span>
//         </Link>
//         <Link
//           to="/admin/upload-pdf"
//           className="bg-white hover:shadow-lg transition-all p-5 rounded-xl border flex flex-col items-center text-center"
//         >
//           <Upload size={28} className="text-indigo-500 mb-2" />
//           <span className="font-semibold">Upload PDF</span>
//         </Link>
//         <Link
//           to="/admin/cleared"
//           className="bg-white hover:shadow-lg transition-all p-5 rounded-xl border flex flex-col items-center text-center"
//         >
//           <ListChecks size={28} className="text-red-500 mb-2" />
//           <span className="font-semibold">Cleared List</span>
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default Dashboard1;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import {
//   Users,
//   FileText,
//   CreditCard,
//   Upload,
//   ListChecks,
//   LayoutDashboard,
//   Receipt,
//   IndianRupee,
//   Building2,
//   AlertCircle,
//   TrendingUp,
//   Clock,
//   CheckCircle2,
//   ArrowUpRight,
//   Calendar,
//   ArrowRight,
//   Sparkles,
// } from "lucide-react";
// import { Api } from "../Api/Api";

// const Dashboard1 = () => {
//   const [bills, setBills] = useState([]);
//   const [creditBills, setCreditBills] = useState([]);
//   const [companies, setCompanies] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const API_BILLS = `${Api}bills/get.php`;
//   const API_BUYERS = `${Api}buyer/get.php`;
//   const API_CREDIT_BILLS = `${Api}bills/get2.php`;

//   useEffect(() => {
//     const fetchAllData = async () => {
//       try {
//         const billsRes = await axios.get(API_BILLS);
//         if (billsRes.data.ok) {
//           setBills(billsRes.data.bills || []);
//         }

//         const creditRes = await axios.get(API_CREDIT_BILLS);
//         if (creditRes.data.ok) {
//           setCreditBills(creditRes.data.bills || []);
//         }

//         const buyersRes = await fetch(API_BUYERS);
//         if (buyersRes.ok) {
//           const data = await buyersRes.json();
//           setCompanies(data || []);
//         }
//       } catch (err) {
//         console.error("Error fetching data:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllData();
//   }, []);

//   const totalBills = bills.length;
//   const totalPaidAmount = bills.reduce(
//     (sum, bill) => sum + parseFloat(bill.paid_amount || 0),
//     0
//   );
//   const totalBuyers = companies.length;

//   const pendingBillsCount = creditBills.length;
//   const totalCreditAmount = creditBills.reduce(
//     (sum, bill) => sum + parseFloat(bill.balance_due || 0),
//     0
//   );
//   const totalCreditGrandTotal = creditBills.reduce(
//     (sum, bill) => sum + parseFloat(bill.grand_total || 0),
//     0
//   );

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-screen bg-gray-50">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600 mx-auto"></div>
//           <p className="mt-4 text-gray-600 font-medium">Loading dashboard...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       className="min-h-screen p-8"
//       style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif" }}
//     >
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
//         * {
//           font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
//         }
        
//         .stat-card {
//           transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//         }
        
//         .stat-card:hover {
//           transform: translateY(-4px);
//           box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
//         }
//       `}</style>

//       <div className="max-w-[1600px] mx-auto">
//         {/* Header */}
//         <div className="mb-10">
//           <div className="flex items-center justify-between">
//             <div>
//               <h1 className="text-4xl font-bold text-gray-900 mb-2 tracking-tight">
//                 Dashboard Overview
//               </h1>
//               <p className="text-gray-500 font-medium flex items-center gap-2">
//                 <Calendar size={18} />
//                 {new Date().toLocaleDateString("en-US", {
//                   weekday: "long",
//                   year: "numeric",
//                   month: "long",
//                   day: "numeric",
//                 })}
//               </p>
//             </div>
           
//           </div>
//         </div>

//         {/* Main Stats Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-10">
//           {/* Total Bills */}
//           <div className="stat-card bg-white rounded-2xl shadow-sm border border-gray-200 p-6 relative overflow-hidden">
//             <div className="absolute top-0 right-0 w-32 h-32 bg-blue-50 rounded-full -mr-16 -mt-16"></div>
//             <div className="relative">
//               <div className="flex items-center justify-between mb-4">
//                 <div className="bg-blue-100 p-3 rounded-xl">
//                   <Receipt className="text-blue-600" size={24} />
//                 </div>
//                 <span className="text-blue-600 text-sm font-semibold">
//                   ↗ 12%
//                 </span>
//               </div>
//               <p className="text-gray-600 font-medium mb-2 text-sm">
//                 Total Bills
//               </p>
//               <p className="text-4xl font-bold text-gray-900 mb-1">
//                 {totalBills}
//               </p>
//               <p className="text-gray-500 text-sm font-medium">
//                 All time invoices
//               </p>
//             </div>
//           </div>

//           {/* Total Revenue */}
//           <div className="stat-card bg-white rounded-2xl shadow-sm border border-gray-200 p-6 relative overflow-hidden">
//             <div className="absolute top-0 right-0 w-32 h-32 bg-green-50 rounded-full -mr-16 -mt-16"></div>
//             <div className="relative">
//               <div className="flex items-center justify-between mb-4">
//                 <div className="bg-green-100 p-3 rounded-xl">
//                   <IndianRupee className="text-green-600" size={24} />
//                 </div>
//                 <span className="text-green-600 text-sm font-semibold">
//                   ↗ 8%
//                 </span>
//               </div>
//               <p className="text-gray-600 font-medium mb-2 text-sm">
//                 Total Revenue
//               </p>
//               <p className="text-3xl font-bold text-gray-900 mb-1">
//                 ₹{(totalPaidAmount / 100000).toFixed(2)}L
//               </p>
//               <p className="text-gray-500 text-sm font-medium">
//                 ₹{totalPaidAmount.toLocaleString("en-IN")}
//               </p>
//             </div>
//           </div>

//           {/* Pending Bills */}
//           <div className="stat-card bg-white rounded-2xl shadow-sm border border-gray-200 p-6 relative overflow-hidden">
//             <div className="absolute top-0 right-0 w-32 h-32 bg-orange-50 rounded-full -mr-16 -mt-16"></div>
//             <div className="relative">
//               <div className="flex items-center justify-between mb-4">
//                 <div className="bg-orange-100 p-3 rounded-xl">
//                   <Clock className="text-orange-600" size={24} />
//                 </div>
//                 <span className="text-orange-600 text-sm font-semibold bg-orange-50 px-2 py-1 rounded">
//                   Alert
//                 </span>
//               </div>
//               <p className="text-gray-600 font-medium mb-2 text-sm">
//                 Pending Bills
//               </p>
//               <p className="text-4xl font-bold text-gray-900 mb-1">
//                 {pendingBillsCount}
//               </p>
//               <p className="text-gray-500 text-sm font-medium">
//                 Needs attention
//               </p>
//             </div>
//           </div>

//           {/* Total Buyers */}
//           <div className="stat-card bg-white rounded-2xl shadow-sm border border-gray-200 p-6 relative overflow-hidden">
//             <div className="absolute top-0 right-0 w-32 h-32 bg-purple-50 rounded-full -mr-16 -mt-16"></div>
//             <div className="relative">
//               <div className="flex items-center justify-between mb-4">
//                 <div className="bg-purple-100 p-3 rounded-xl">
//                   <Building2 className="text-purple-600" size={24} />
//                 </div>
//                 <span className="text-purple-600 text-sm font-semibold">
//                   Active
//                 </span>
//               </div>
//               <p className="text-gray-600 font-medium mb-2 text-sm">
//                 Total Buyers
//               </p>
//               <p className="text-4xl font-bold text-gray-900 mb-1">
//                 {totalBuyers}
//               </p>
//               <p className="text-gray-500 text-sm font-medium">
//                 Active companies
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Credit Details & Statistics */}
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-10">
//           {/* Credit Overview - Takes 2 columns */}
//           <div className="lg:col-span-2 bg-gradient-to-br from-red-500 via-red-600 to-red-700 rounded-2xl shadow-xl p-8 text-white relative overflow-hidden">
//             <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -mr-32 -mt-32"></div>
//             <div className="absolute bottom-0 left-0 w-48 h-48 bg-white opacity-5 rounded-full -ml-24 -mb-24"></div>

//             <div className="relative">
//               <div className="flex items-center justify-between mb-8">
//                 <div>
//                   <h3 className="text-2xl font-bold mb-1 flex items-center gap-3">
//                     <AlertCircle size={28} />
//                     Credit Overview
//                   </h3>
//                   <p className="text-red-100 font-medium">
//                     Outstanding payment details
//                   </p>
//                 </div>
//                 <Link
//                   to="/admin/credit-details"
//                   className="bg-white text-red-600 px-6 py-3 rounded-xl font-bold hover:bg-red-50 transition-all flex items-center gap-2 shadow-lg"
//                 >
//                   View All
//                   <ArrowRight size={18} />
//                 </Link>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div className="bg-white/15 backdrop-blur-md rounded-xl p-6 border border-white/20">
//                   <p className="text-red-100 font-semibold mb-2 text-sm">
//                     Total Credit Amount
//                   </p>
//                   <p className="text-4xl font-black mb-2">
//                     ₹{(totalCreditGrandTotal / 100000).toFixed(2)}L
//                   </p>
//                   <p className="text-red-100 text-sm font-medium">
//                     ₹
//                     {totalCreditGrandTotal.toLocaleString("en-IN", {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2,
//                     })}
//                   </p>
//                 </div>

//                 <div className="bg-white/15 backdrop-blur-md rounded-xl p-6 border border-white/20">
//                   <p className="text-red-100 font-semibold mb-2 text-sm">
//                     Outstanding Balance
//                   </p>
//                   <p className="text-4xl font-black mb-2">
//                     ₹{(totalCreditAmount / 100000).toFixed(2)}L
//                   </p>
//                   <p className="text-red-100 text-sm font-medium">
//                     ₹
//                     {totalCreditAmount.toLocaleString("en-IN", {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2,
//                     })}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Payment Statistics */}
//           <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
//             <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
//               <div className="bg-green-100 p-2 rounded-lg">
//                 <CheckCircle2 size={20} className="text-green-600" />
//               </div>
//               Payment Stats
//             </h3>

//             <div className="space-y-4">
//               <div className="bg-gradient-to-br from-green-50 to-green-100 p-5 rounded-xl border border-green-200">
//                 <p className="text-gray-700 font-semibold mb-2 text-sm">
//                   Collection Rate
//                 </p>
//                 <p className="text-3xl font-black text-green-700">
//                   {totalCreditGrandTotal > 0
//                     ? (
//                         ((totalCreditGrandTotal - totalCreditAmount) /
//                           totalCreditGrandTotal) *
//                         100
//                       ).toFixed(1)
//                     : 0}
//                   %
//                 </p>
//               </div>

//               <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 p-5 rounded-xl border border-indigo-200">
//                 <p className="text-gray-700 font-semibold mb-2 text-sm">
//                   Avg Bill Value
//                 </p>
//                 <p className="text-2xl font-black text-indigo-700">
//                   ₹
//                   {totalBills > 0
//                     ? (totalPaidAmount / totalBills).toLocaleString("en-IN", {
//                         maximumFractionDigits: 0,
//                       })
//                     : "0"}
//                 </p>
//               </div>

//               <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-5 rounded-xl border border-orange-200">
//                 <p className="text-gray-700 font-semibold mb-2 text-sm">
//                   Recovery Pending
//                 </p>
//                 <p className="text-3xl font-black text-orange-700">
//                   {pendingBillsCount} Bills
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Quick Actions */}
//         <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
//           <div className="flex items-center justify-between mb-6">
//             <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
//               <div className="bg-indigo-100 p-2 rounded-xl">
//                 <Sparkles className="text-indigo-600" size={24} />
//               </div>
//               Quick Actions
//             </h2>
//           </div>

//           <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
//             <Link
//               to="/admin/buyer"
//               className="group bg-gradient-to-br from-blue-50 to-blue-100 hover:from-blue-500 hover:to-blue-600 transition-all p-6 rounded-xl border-2 border-blue-200 hover:border-blue-500 flex flex-col items-center text-center"
//             >
//               <div className="bg-white p-4 rounded-xl mb-3 shadow-sm group-hover:shadow-md transition-all">
//                 <Users size={28} className="text-blue-600" />
//               </div>
//               <span className="font-bold text-gray-800 group-hover:text-white transition-all">
//                 Buyer Info
//               </span>
//             </Link>

//             <Link
//               to="/admin/voucher-entry"
//               className="group bg-gradient-to-br from-green-50 to-green-100 hover:from-green-500 hover:to-green-600 transition-all p-6 rounded-xl border-2 border-green-200 hover:border-green-500 flex flex-col items-center text-center"
//             >
//               <div className="bg-white p-4 rounded-xl mb-3 shadow-sm group-hover:shadow-md transition-all">
//                 <FileText size={28} className="text-green-600" />
//               </div>
//               <span className="font-bold text-gray-800 group-hover:text-white transition-all">
//                 Voucher Entry
//               </span>
//             </Link>

//             <Link
//               to="/admin/billing-details"
//               className="group bg-gradient-to-br from-orange-50 to-orange-100 hover:from-orange-500 hover:to-orange-600 transition-all p-6 rounded-xl border-2 border-orange-200 hover:border-orange-500 flex flex-col items-center text-center"
//             >
//               <div className="bg-white p-4 rounded-xl mb-3 shadow-sm group-hover:shadow-md transition-all">
//                 <CreditCard size={28} className="text-orange-600" />
//               </div>
//               <span className="font-bold text-gray-800 group-hover:text-white transition-all">
//                 Bill Details
//               </span>
//             </Link>

//             <Link
//               to="/admin/upload-pdf"
//               className="group bg-gradient-to-br from-indigo-50 to-indigo-100 hover:from-indigo-500 hover:to-indigo-600 transition-all p-6 rounded-xl border-2 border-indigo-200 hover:border-indigo-500 flex flex-col items-center text-center"
//             >
//               <div className="bg-white p-4 rounded-xl mb-3 shadow-sm group-hover:shadow-md transition-all">
//                 <Upload size={28} className="text-indigo-600" />
//               </div>
//               <span className="font-bold text-gray-800 group-hover:text-white transition-all">
//                 Upload PDF
//               </span>
//             </Link>

//             <Link
//               to="/admin/cleared"
//               className="group bg-gradient-to-br from-red-50 to-red-100 hover:from-red-500 hover:to-red-600 transition-all p-6 rounded-xl border-2 border-red-200 hover:border-red-500 flex flex-col items-center text-center"
//             >
//               <div className="bg-white p-4 rounded-xl mb-3 shadow-sm group-hover:shadow-md transition-all">
//                 <ListChecks size={28} className="text-red-600" />
//               </div>
//               <span className="font-bold text-gray-800 group-hover:text-white transition-all">
//                 Cleared List
//               </span>
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard1;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  Users,
  FileText,
  CreditCard,
  Upload,
  ListChecks,
  LayoutDashboard,
  Receipt,
  IndianRupee,
  Building2,
  AlertCircle,
  TrendingUp,
  Clock,
  CheckCircle2,
  ArrowUpRight,
  Calendar,
  ArrowRight,
  Sparkles,
} from "lucide-react";
import { Api } from "../Api/Api";

const Dashboard1 = () => {
  const [bills, setBills] = useState([]);
  const [creditBills, setCreditBills] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_BILLS = `${Api}bills/get.php`;
  const API_BUYERS = `${Api}buyer/get.php`;
  const API_CREDIT_BILLS = `${Api}bills/get2.php`;

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const billsRes = await axios.get(API_BILLS);
        if (billsRes.data.ok) {
          setBills(billsRes.data.bills || []);
        }

        const creditRes = await axios.get(API_CREDIT_BILLS);
        if (creditRes.data.ok) {
          setCreditBills(creditRes.data.bills || []);
        }

        const buyersRes = await fetch(API_BUYERS);
        if (buyersRes.ok) {
          const data = await buyersRes.json();
          setCompanies(data || []);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  const totalBills = bills.length;
  const totalPaidAmount = bills.reduce(
    (sum, bill) => sum + parseFloat(bill.paid_amount || 0),
    0
  );
  const totalBuyers = companies.length;

  const pendingBillsCount = creditBills.length;
  const totalCreditAmount = creditBills.reduce(
    (sum, bill) => sum + parseFloat(bill.balance_due || 0),
    0
  );
  const totalCreditGrandTotal = creditBills.reduce(
    (sum, bill) => sum + parseFloat(bill.grand_total || 0),
    0
  );


  // Get current month's bills count
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  const currentMonthBills = bills.filter((bill) => {
    const billDate = new Date(bill.bill_date || bill.created_at);
    return (
      billDate.getMonth() === currentMonth &&
      billDate.getFullYear() === currentYear
    );
  }).length;

  const lastMonthBills = bills.filter((bill) => {
    const billDate = new Date(bill.bill_date || bill.created_at);
    const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
    const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear;
    return (
      billDate.getMonth() === lastMonth &&
      billDate.getFullYear() === lastMonthYear
    );
  }).length;

  // Calculate percentage growth
  const billsGrowth =
    lastMonthBills > 0
      ? (((currentMonthBills - lastMonthBills) / lastMonthBills) * 100).toFixed(
          1
        )
      : 0;

  // Calculate revenue growth
  const currentMonthRevenue = bills
    .filter((bill) => {
      const billDate = new Date(bill.bill_date || bill.created_at);
      return (
        billDate.getMonth() === currentMonth &&
        billDate.getFullYear() === currentYear
      );
    })
    .reduce((sum, bill) => sum + parseFloat(bill.paid_amount || 0), 0);

  const lastMonthRevenue = bills
    .filter((bill) => {
      const billDate = new Date(bill.bill_date || bill.created_at);
      const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
      const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear;
      return (
        billDate.getMonth() === lastMonth &&
        billDate.getFullYear() === lastMonthYear
      );
    })
    .reduce((sum, bill) => sum + parseFloat(bill.paid_amount || 0), 0);

  const revenueGrowth =
    lastMonthRevenue > 0
      ? (
          ((currentMonthRevenue - lastMonthRevenue) / lastMonthRevenue) *
          100
        ).toFixed(1)
      : 0;

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 font-medium">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen p-8"
      style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif" }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        * {
          font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
        }
        
        .stat-card {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .stat-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        }
      `}</style>

      <div className="max-w-[1600px] mx-auto">
        {/* Header */}
        <div className="mb-10">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold text-gray-900 mb-2 tracking-tight">
                Dashboard Overview
              </h1>
              <p className="text-gray-500 font-medium flex items-center gap-2">
                <Calendar size={18} />
                {new Date().toLocaleDateString("en-US", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>
          </div>
        </div>

        {/* Main Stats Grid - PROFESSIONAL DESIGN */}
        {/* Main Stats Grid - PREMIUM CARD STYLE */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-10">
          {/* Total Bills */}
          <div className="stat-card bg-white rounded-2xl shadow-sm border border-gray-200 p-6 relative overflow-hidden hover:shadow-md transition-all">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-50 rounded-full -mr-16 -mt-16"></div>

            <div className="relative">
              <div className="flex items-center justify-between mb-4">
                <div className="bg-blue-100 p-3 rounded-xl">
                  <Receipt className="text-blue-600" size={24} />
                </div>

                {billsGrowth !== 0 && (
                  <span
                    className={`text-sm font-semibold ${
                      billsGrowth > 0 ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    {billsGrowth > 0 ? "↗" : "↘"} {Math.abs(billsGrowth)}%
                  </span>
                )}
              </div>

              <p className="text-gray-600 font-medium mb-2 text-sm">
                Total Bills
              </p>
              <p className="text-4xl font-bold text-gray-900 mb-1">
                {totalBills}
              </p>
              <p className="text-gray-500 text-sm font-medium">
                {currentMonthBills} bills this month
              </p>
            </div>
          </div>

          {/* Total Revenue */}
          <div className="stat-card bg-white rounded-2xl shadow-sm border border-gray-200 p-6 relative overflow-hidden hover:shadow-md transition-all">
            <div className="absolute top-0 right-0 w-32 h-32 bg-green-50 rounded-full -mr-16 -mt-16"></div>

            <div className="relative">
              <div className="flex items-center justify-between mb-4">
                <div className="bg-green-100 p-3 rounded-xl">
                  <IndianRupee className="text-green-600" size={24} />
                </div>

                {revenueGrowth !== 0 && (
                  <span
                    className={`text-sm font-semibold ${
                      revenueGrowth > 0 ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    {revenueGrowth > 0 ? "↗" : "↘"} {Math.abs(revenueGrowth)}%
                  </span>
                )}
              </div>

              <p className="text-gray-600 font-medium mb-2 text-sm">
                Total Revenue
              </p>
              <p className="text-4xl font-bold text-gray-900 mb-1">
                ₹{(totalPaidAmount / 100000).toFixed(2)}L
              </p>
              <p className="text-gray-500 text-sm font-medium">
                ₹{totalPaidAmount.toLocaleString("en-IN")}
              </p>
            </div>
          </div>

          {/* Pending Bills */}
          <div className="stat-card bg-white rounded-2xl shadow-sm border border-gray-200 p-6 relative overflow-hidden hover:shadow-md transition-all">
            <div className="absolute top-0 right-0 w-32 h-32 bg-orange-50 rounded-full -mr-16 -mt-16"></div>

            <div className="relative">
              <div className="flex items-center justify-between mb-4">
                <div className="bg-orange-100 p-3 rounded-xl">
                  <Clock className="text-orange-600" size={24} />
                </div>

                {pendingBillsCount > 0 && (
                  <span className="text-orange-600 text-sm font-semibold bg-orange-50 px-2 py-1 rounded">
                    Alert
                  </span>
                )}
              </div>

              <p className="text-gray-600 font-medium mb-2 text-sm">
                Pending Bills
              </p>
              <p className="text-4xl font-bold text-gray-900 mb-1">
                {pendingBillsCount}
              </p>
              <p className="text-gray-500 text-sm font-medium">
                ₹{(totalCreditAmount / 100000).toFixed(2)}L outstanding
              </p>
            </div>
          </div>

          {/* Total Buyers */}
          <div className="stat-card bg-white rounded-2xl shadow-sm border border-gray-200 p-6 relative overflow-hidden hover:shadow-md transition-all">
            <div className="absolute top-0 right-0 w-32 h-32 bg-purple-50 rounded-full -mr-16 -mt-16"></div>

            <div className="relative">
              <div className="flex items-center justify-between mb-4">
                <div className="bg-purple-100 p-3 rounded-xl">
                  <Building2 className="text-purple-600" size={24} />
                </div>

                <span className="text-purple-600 text-sm font-semibold">
                  Active
                </span>
              </div>

              <p className="text-gray-600 font-medium mb-2 text-sm">
                Total Buyers
              </p>
              <p className="text-4xl font-bold text-gray-900 mb-1">
                {totalBuyers}
              </p>
              <p className="text-gray-500 text-sm font-medium">
                Active business partners
              </p>
            </div>
          </div>
        </div>

        {/* Credit Details & Statistics */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-10">
          {/* Credit Overview - Takes 2 columns */}
          <div className="lg:col-span-2 bg-gradient-to-br from-red-500 via-red-600 to-red-700 rounded-2xl shadow-xl p-8 text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white opacity-5 rounded-full -ml-24 -mb-24"></div>

            <div className="relative">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h3 className="text-2xl font-bold mb-1 flex items-center gap-3">
                    <AlertCircle size={28} />
                    Credit Overview
                  </h3>
                  <p className="text-red-100 font-medium">
                    Outstanding payment details
                  </p>
                </div>
                <Link
                  to="/admin/credit-details"
                  className="bg-white text-red-600 px-6 py-3 rounded-xl font-bold hover:bg-red-50 transition-all flex items-center gap-2 shadow-lg"
                >
                  View All
                  <ArrowRight size={18} />
                </Link>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white/15 backdrop-blur-md rounded-xl p-6 border border-white/20">
                  <p className="text-red-100 font-semibold mb-2 text-sm">
                    Total Credit Amount
                  </p>
                  <p className="text-4xl font-black mb-2">
                    ₹{(totalCreditGrandTotal / 100000).toFixed(2)}L
                  </p>
                  <p className="text-red-100 text-sm font-medium">
                    ₹
                    {totalCreditGrandTotal.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </div>

                <div className="bg-white/15 backdrop-blur-md rounded-xl p-6 border border-white/20">
                  <p className="text-red-100 font-semibold mb-2 text-sm">
                    Outstanding Balance
                  </p>
                  <p className="text-4xl font-black mb-2">
                    ₹{(totalCreditAmount / 100000).toFixed(2)}L
                  </p>
                  <p className="text-red-100 text-sm font-medium">
                    ₹
                    {totalCreditAmount.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Statistics */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
              <div className="bg-green-100 p-2 rounded-lg">
                <CheckCircle2 size={20} className="text-green-600" />
              </div>
              Payment Stats
            </h3>

            <div className="space-y-4">
              <div className="bg-gradient-to-br from-green-50 to-green-100 p-5 rounded-xl border border-green-200">
                <p className="text-gray-700 font-semibold mb-2 text-sm">
                  Collection Rate
                </p>
                <p className="text-3xl font-black text-green-700">
                  {totalCreditGrandTotal > 0
                    ? (
                        ((totalCreditGrandTotal - totalCreditAmount) /
                          totalCreditGrandTotal) *
                        100
                      ).toFixed(1)
                    : 0}
                  %
                </p>
              </div>

              <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 p-5 rounded-xl border border-indigo-200">
                <p className="text-gray-700 font-semibold mb-2 text-sm">
                  Avg Bill Value
                </p>
                <p className="text-2xl font-black text-indigo-700">
                  ₹
                  {totalBills > 0
                    ? (totalPaidAmount / totalBills).toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })
                    : "0"}
                </p>
              </div>

              <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-5 rounded-xl border border-orange-200">
                <p className="text-gray-700 font-semibold mb-2 text-sm">
                  Recovery Pending
                </p>
                <p className="text-3xl font-black text-orange-700">
                  {pendingBillsCount} Bills
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
              <div className="bg-indigo-100 p-2 rounded-xl">
                <Sparkles className="text-indigo-600" size={24} />
              </div>
              Quick Actions
            </h2>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            <Link
              to="/admin/buyer"
              className="group bg-gradient-to-br from-blue-50 to-blue-100 hover:from-blue-500 hover:to-blue-600 transition-all p-6 rounded-xl border-2 border-blue-200 hover:border-blue-500 flex flex-col items-center text-center"
            >
              <div className="bg-white p-4 rounded-xl mb-3 shadow-sm group-hover:shadow-md transition-all">
                <Users size={28} className="text-blue-600" />
              </div>
              <span className="font-bold text-gray-800 group-hover:text-white transition-all">
                Buyer Info
              </span>
            </Link>

            <Link
              to="/admin/voucher-entry"
              className="group bg-gradient-to-br from-green-50 to-green-100 hover:from-green-500 hover:to-green-600 transition-all p-6 rounded-xl border-2 border-green-200 hover:border-green-500 flex flex-col items-center text-center"
            >
              <div className="bg-white p-4 rounded-xl mb-3 shadow-sm group-hover:shadow-md transition-all">
                <FileText size={28} className="text-green-600" />
              </div>
              <span className="font-bold text-gray-800 group-hover:text-white transition-all">
                Voucher Entry
              </span>
            </Link>

            <Link
              to="/admin/billing-details"
              className="group bg-gradient-to-br from-orange-50 to-orange-100 hover:from-orange-500 hover:to-orange-600 transition-all p-6 rounded-xl border-2 border-orange-200 hover:border-orange-500 flex flex-col items-center text-center"
            >
              <div className="bg-white p-4 rounded-xl mb-3 shadow-sm group-hover:shadow-md transition-all">
                <CreditCard size={28} className="text-orange-600" />
              </div>
              <span className="font-bold text-gray-800 group-hover:text-white transition-all">
                Bill Details
              </span>
            </Link>

            <Link
              to="/admin/upload-pdf"
              className="group bg-gradient-to-br from-indigo-50 to-indigo-100 hover:from-indigo-500 hover:to-indigo-600 transition-all p-6 rounded-xl border-2 border-indigo-200 hover:border-indigo-500 flex flex-col items-center text-center"
            >
              <div className="bg-white p-4 rounded-xl mb-3 shadow-sm group-hover:shadow-md transition-all">
                <Upload size={28} className="text-indigo-600" />
              </div>
              <span className="font-bold text-gray-800 group-hover:text-white transition-all">
                Upload PDF
              </span>
            </Link>

            <Link
              to="/admin/cleared"
              className="group bg-gradient-to-br from-red-50 to-red-100 hover:from-red-500 hover:to-red-600 transition-all p-6 rounded-xl border-2 border-red-200 hover:border-red-500 flex flex-col items-center text-center"
            >
              <div className="bg-white p-4 rounded-xl mb-3 shadow-sm group-hover:shadow-md transition-all">
                <ListChecks size={28} className="text-red-600" />
              </div>
              <span className="font-bold text-gray-800 group-hover:text-white transition-all">
                Cleared List
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard1;